<h2 class="d-flex justify-content-center align-items-center mt-3 hearder-text">Share Resume</h2>
<div class="d-flex justify-content-center align-items-center button-container">
    <button mat-raised-button class="copy-link-btn" (click)="copyLink()" [style.background-color]="!linkCopied ? '#0d87c8' : '#2c3e9f'" style="color: white;" >
      <mat-icon *ngIf="!linkCopied">content_copy</mat-icon>
      <span *ngIf="!linkCopied" >Copy Link</span>
      <span *ngIf="linkCopied">Link Copied!</span>
    </button>
    <button mat-raised-button class="close-btn" (click)="closeDialog()">Close</button>
  </div>
  